// checkout.js
export const FETCH_CHECKOUT_ORDER_SUMMARY = 'FETCH_CHECKOUT_ORDER_SUMMARY'
export const FETCH_CHECKOUT_ORDER_SUMMARYSUCCESS = 'FETCH_CHECKOUT_ORDER_SUMMARY_SUCCESS'
export const FETCH_CHECKOUT_ORDER_SUMMARY_FAILURE = 'FETCH_CHECKOUT_ORDER_SUMMARY_FAILURE'
export const SET_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEMS = 'SET_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEMS'
export const MERGE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEMS = 'MERGE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEMS'
export const SET_CHECKOUT_ORDER_SUMMARY_LOADING = 'SET_CHECKOUT_ORDER_SUMMARY_LOADING'
export const SET_CHECKOUT_ORDER_SUMMARY_ID = 'SET_CHECKOUT_ORDER_SUMMARY_ID'
export const SET_CHECKOUT_UNIT_SUMMARY = 'SET_CHECKOUT_UNIT_SUMMARY'
export const SET_CHECKOUT_SELECTED_GROUP_BY = 'SET_CHECKOUT_SELECTED_GROUP_BY'
export const SET_CHECKOUT_SELECTED_SORT_BY = 'SET_CHECKOUT_SELECTED_SORT_BY'
export const TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_CHECKBOX = 'TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_CHECKBOX'
export const TOGGLE_CHECKOUT_ORDER_SUMMARY_SELECT_UNSELECT_CHECKBOX = 'TOGGLE_CHECKOUT_ORDER_SUMMARY_SELECT_UNSELECT_CHECKBOX'
export const TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_PROPERTY = 'TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_PROPERTY'
export const TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_PARENT_PROPERTY = 'TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_PARENT_PROPERTY'
export const TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_CHILD_PROPERTY = 'TOGGLE_CHECKOUT_ORDER_SUMMARY_PRODUCT_ITEM_CHILD_PROPERTY'
export const CREATE_CARD_INFO = 'CREATE_CARD_INFO'
export const UPDATE_CARD_INFO = 'UPDATE_CARD_INFO'
export const DELETE_CARD_INFO = 'DELETE_CARD_INFO'
export const DELETE_BULK_PRODUCT_FROM_ORDER = 'DELETE_BULK_PRODUCT_FROM_ORDER'
export const DUPLICATE_TO_OTHER_PRODUCTS = 'DUPLICATE_TO_OTHER_PRODUCTS'
export const FETCH_CREDIT_CARD_DETAIL = 'FETCH_CREDIT_CARD_DETAIL'
export const SET_QUANTITY_EXCEED = 'SET_QUANTITY_EXCEED'
export const REMOVE_QUANTITY_EXCEED = 'REMOVE_QUANTITY_EXCEED'
export const SET_ORDER_REVIEW_DELIVERIES = 'SET_ORDER_REVIEW_DELIVERIES'
export const SET_CATALOG_VERSION = 'SET_CATALOG_VERSION'
